import { render, staticRenderFns } from "./DeeplinkAndQr.vue?vue&type=template&id=637ba22c&scoped=true&lang=pug"
import script from "./DeeplinkAndQr.vue?vue&type=script&lang=js"
export * from "./DeeplinkAndQr.vue?vue&type=script&lang=js"
import style0 from "./DeeplinkAndQr.vue?vue&type=style&index=0&id=637ba22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637ba22c",
  null
  
)

export default component.exports